import styled from 'styled-components'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.boxShadow.level2};
    border-radius: 10px;
    padding: 30px;
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};
    margin-bottom: 10px;
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};

    a {
        text-decoration: none;
        color: ${(props) => props.theme.color.p500};
        ${(props) => props.theme.fontWeight.medium};
    }
`
